<div class="title">
    <ng-content select="[title]"></ng-content>
</div>
<div class="navigation-sheet">
    <ng-content select="[card]"></ng-content>
</div>
